export default "__VITE_ASSET__C6KhTR8w__"